import { PlatformHealthCard } from '../components/PlatformHealthCard';
import { ActiveUsersChart } from '../components/ActiveUsersChart';
import { AutomationStatusCard } from '../components/AutomationStatusCard';
import { RevenueCard } from '../components/RevenueCard';
import { RecentActivityFeed } from '../components/RecentActivityFeed';
import { SystemAlertsCard } from '../components/SystemAlertsCard';

export function AdminDashboardPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Dashboard</h1>
        <p className="text-sm text-neutral-500">Vue d'ensemble de la plateforme</p>
      </div>

      {/* Top row - KPI cards */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
        <PlatformHealthCard />
        <ActiveUsersChart />
        <AutomationStatusCard />
        <RevenueCard />
      </div>

      {/* Bottom row */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <RecentActivityFeed />
        <SystemAlertsCard />
      </div>
    </div>
  );
}
